import { selectUserId } from "domain/auth/auth.selectors";
import { PropsWithChildren, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { CustomTooltip } from "ui/pages/app/components/CustomTooltip";
import { selectOnBoardingValues } from "domain/on-boarding/on-boarding.selectors";
import { updateOnBoardingValue } from "ui/utils/on-boarding-storage";

export const VisualSupportsTooltip = ({ children }: PropsWithChildren<{}>) => {
  const dispatch = useAppDispatch();
  const onBoardingValues = useAppSelector(selectOnBoardingValues);
  const userId = useAppSelector(selectUserId);

  const closeVisualSupportsTooltip = () => {
    if (!onBoardingValues.closedVisualSupportsTooltip) {
      updateOnBoardingValue(userId, "closedVisualSupportsTooltip", dispatch);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", closeVisualSupportsTooltip);
    return () => {
      closeVisualSupportsTooltip();
    };
  }, []); //eslint-disable-line

  return onBoardingValues.closedVisualSupportsTooltip ? (
    <>{children}</>
  ) : (
    <CustomTooltip
      open
      onClose={closeVisualSupportsTooltip}
      title={translate("ns1:OnBoarding.Tooltips.VisualSupportsTooltipTitle")}
      text={translate("ns1:OnBoarding.Tooltips.VisualSupportsTooltipText")}
    >
      {children}
    </CustomTooltip>
  );
};
